import store from "../redux/store";
import { wsMsgSeparatorChar } from "./websocketHelper";
import { updateSymbolInfos, updateSymbolChart, updateSymbolPriceChart, updatePutThroughInfo, updateSymbolTPRLInfos } from "../redux/actions/symbolActions";

const arrColor = new Array(
   "", // None
   "clr-ceil",
   "clr-floor",
   "clr-ref",
   "clr-down",
   "clr-up"
);

const arrColorTPRL = new Array(
   "", //0 --white,
   "clr-ceil",
   "clr-floor",
   "clr-ref",
   "clr-down",
   "clr-up" //5
);

const arrStockMsgField = new Array(
   "code", //0
   "ceilPrice",
   "floorPrice",
   "refPrice",
   "bidPrice3",
   "bidQtty3", //5
   "bidPrice2",
   "bidQtty2",
   "bidPrice1",
   "bidQtty1",
   "offerPrice3", //10
   "offerQtty3",
   "offerPrice2",
   "offerQtty2",
   "offerPrice1",
   "offerQtty1", //15
   "matchPrice",
   "changePrice",
   "pctChangePrice",
   "matchQtty",
   "totalTradedQtty", //20
   "totalTradedValue",
   "highestPrice",
   "avgPrice",
   "lowestPrice",
   "buyForeignQtty", //25
   "buyForeignValue",
   "sellForeignQtty",
   "sellForeignValue",
   "remainForeignQtty",
   "openPrice", //30
   "closePrice",
   "openInterest",
   "openInterestChange",
   "marketCode",
   "floorCode", //35
   "indexCodes",
   "issuer",
   "issuerName",
   "exercisePrice",
   "exerciseRatio", //40
   "underlying",
   "underlyingPrice",
   "priorClosePrice",
   "securityTradingStatus",
   "securityType", //45
   "tradeSessionCode",
   "marketName",
   "marketNameEn",
   "totalBidQtty",
   "totalOfferQtty", //50
   "subForeignQtty",
   "subForeignValue",
   "changeTotalTradedQtty",
   "avgTotalTradedQtty10Days",
   "totalBuyQtty", //55
   "totalBuyValue",
   "totalSellQtty",
   "totalSellValue",
   "symbolName",
   "basis", //60
   "totalTradedQttyNM",
   "totalTradedValueNM",
   "totalTradedQttyPT",
   "totalTradedValuePT",
   "referenceStatus", //65
   "matchPriceOdd",
   "changePriceOdd",
   "pctChangePriceOdd",
   "matchQttyOdd",
   "totalTradedQttyOdd", //70
   "totalTradedValueOdd",
   "bidPriceOdd3",
   "bidQttyOdd3",
   "bidPriceOdd2",
   "bidQttyOdd2", // 75
   "bidPriceOdd1",
   "bidQttyOdd1",
   "offerPriceOdd3",
   "offerQttyOdd3",
   "offerPriceOdd2", // 80
   "offerQttyOdd2",
   "offerPriceOdd1",
   "offerQttyOdd1",
   "lastTradingDate",
   "dhv", // 85
   "congTru",
   "underlyingPriceCS",
   // "parvalue"
   "bidPrice4", //88
   "bidQtty4",

   "bidPrice5",
   "bidQtty5",

   "bidPrice6",
   "bidQtty6",

   "bidPrice7",
   "bidQtty7",

   "bidPrice8",
   "bidQtty8",

   "bidPrice9",
   "bidQtty9",

   "bidPrice10", // 100
   "bidQtty10",

   "offerPrice4",
   "offerQtty4",

   "offerPrice5",
   "offerQtty5",

   "offerPrice6",
   "offerQtty6",

   "offerPrice7",
   "offerQtty7",

   "offerPrice8",
   "offerQtty8",

   "offerPrice9",
   "offerQtty9",

   "offerPrice10",
   "offerQtty10" //115
);

const arrPutThroughMsgField = new Array(
   "ticks",
   "time",
   "symbol",
   "marketCode",
   "partyId",
   "traderId", //5
   "price",
   "quantity",
   "value",
   "side",
   "type"
);

const arrStockTPRLField = new Array(
   "symbol",
   "code", //0
   // "totalListingQtty",
   // "boardCode",
   // "securityTradingStatus",
   // "tradingSessionId",
   // "tradSesStatus", //5
   // "issueDate",
   // "issuer",
   // "maturitDate",
   // "interestRate",
   // "periodRemain", //10
   // "totalVolumeTraded",
   // "totalValueTraded",
   // "pt_MatchQtty",
   // "pt_MatchPrice",
   // "pt_MaxQtty", //15
   // "pt_MaxPrice",
   // "pt_MinQtty",
   // "pt_MinPrice",
   // "pt_TotalTradedQtty",
   // "pt_TotalTradedValue", //20
   // "pt_BestBidQtty",
   // "pt_BestBidPrice",
   // "pt_BestOfferQtty",
   // "pt_BestOfferPrice",
   // "pt_TotalBidQtty", //25
   // "pt_TotalOfferQtty",
   // "tsdb",
   "issuer",
   "maturityDate",
   "basicPrice",
   "pt_TotalBidQtty",
   "pt_BestBidQtty",
   "pt_BestBidPrice",
   "pt_MatchPrice",
   "pt_MatchQtty",
   "pt_MaxPrice",
   "pt_MaxQtty",
   "pt_MinPrice",
   "pt_MinQtty",
   "pt_BestOfferPrice",
   "pt_BestOfferQtty",
   "pt_TotalOfferQtty",
   "pt_TotalTradedQtty",
   "pt_TotalTradedValue",
   "interestRate",
);

export const ClearAllStockChart = () => {
   store.dispatch(updateSymbolChart({}));
   store.dispatch(updateSymbolPriceChart({}));
   store.dispatch(updatePutThroughInfo({ counter: 0, datas: [] }));
};

export const ProcessMsgStock = (message, isInit) => {
   try {
      // console.log(message);
      let _old = store.getState().gSymbol.symbolInfos;
      let _msgs = message.split(wsMsgSeparatorChar.ObjectSeparatorChar);
      for (let _msgIdx = 0; _msgIdx < _msgs.length; _msgIdx++) {
         if (_msgs[_msgIdx] !== "") {
            const _firstIdx = _msgs[_msgIdx].indexOf(wsMsgSeparatorChar.PropSeparatorChar);
            const _code = _msgs[_msgIdx].substr(0, _firstIdx);
            let _rIndex = _old.findIndex((item) => item.code === _code);
            if (_rIndex < 0) {
               isInit = true;
               _old.push({ code: _code, counter: 0, closePriceHistChart: "", foreignTradeHistChart: "" });
               _rIndex = _old.length - 1;
            }
            //
            let _objTemp = _old[_rIndex];
            let _changed = false;
            const _arrData = _msgs[_msgIdx].substr(_firstIdx).split(wsMsgSeparatorChar.PropSeparatorChar);

            for (let _dataIdx = 0; _dataIdx < _arrData.length; _dataIdx++) {
               if (_arrData[_dataIdx] !== "") {
                  let _arrSubData = _arrData[_dataIdx].split(wsMsgSeparatorChar.DataSeparatorChar);
                  const _propIndex = Number(_arrSubData[0]);
                  if (_propIndex < arrStockMsgField.length) {
                     let _objProp = arrStockMsgField[_propIndex];
                     _objTemp[_objProp] = _arrSubData[1];
                     if (_arrSubData.length >= 3) {
                        _objTemp[_objProp + "_color"] = arrColor[Number(_arrSubData[2])];
                     }
                     _changed = true;
                  }
               }
            }
            //
            if (_changed) {
               _objTemp.counter = _objTemp.counter + 1;
            }
            //
            _old[_rIndex] = _objTemp;
         }
      }

      store.dispatch(updateSymbolInfos(_old, isInit));
   } catch (error) {}
};

//
export const ProcessMsgStockClosePriceHistChart = (message) => {
   try {
      if (message === undefined || message === null || message === "") {
         return;
      }
      //
      let _old = store.getState().gSymbol.symbolInfos;
      let _msgs = message.split(wsMsgSeparatorChar.ObjectSeparatorChar);
      for (let _msgIdx = 0; _msgIdx < _msgs.length; _msgIdx++) {
         if (_msgs[_msgIdx] !== "") {
            const _firstIdx = _msgs[_msgIdx].indexOf(wsMsgSeparatorChar.PropSeparatorChar);
            const _code = _msgs[_msgIdx].substr(0, _firstIdx);
            let _rIndex = _old.findIndex((item) => item.code === _code);
            if (_rIndex < 0) {
               continue;
            }
            //
            let _objTemp = _old[_rIndex];
            _objTemp.closePriceHistChart = _msgs[_msgIdx].substr(_firstIdx);
            _objTemp.counter = _objTemp.counter + 1;
            //
            _old[_rIndex] = _objTemp;
         }
      }
      //
      store.dispatch(updateSymbolInfos(_old, false));
   } catch (error) {}
};

//
export const ProcessMsgStockForeignTradeHistChart = (message) => {
   try {
      if (message === undefined || message === null || message === "") {
         return;
      }
      //
      let _old = store.getState().gSymbol.symbolInfos;
      let _msgs = message.split(wsMsgSeparatorChar.ObjectSeparatorChar);
      for (let _msgIdx = 0; _msgIdx < _msgs.length; _msgIdx++) {
         if (_msgs[_msgIdx] !== "") {
            const _firstIdx = _msgs[_msgIdx].indexOf(wsMsgSeparatorChar.PropSeparatorChar);
            const _code = _msgs[_msgIdx].substr(0, _firstIdx);
            let _rIndex = _old.findIndex((item) => item.code === _code);
            if (_rIndex < 0) {
               continue;
            }
            //
            let _objTemp = _old[_rIndex];
            _objTemp.foreignTradeHistChart = _msgs[_msgIdx].substr(_firstIdx);
            _objTemp.counter = _objTemp.counter + 1;
            //
            _old[_rIndex] = _objTemp;
         }
      }
      //
      store.dispatch(updateSymbolInfos(_old, false));
   } catch (error) {}
};

//
export const ProcessMsgStockMatchChart = (message) => {
   try {
      if (message === undefined || message === null || message === "") {
         return;
      }
      //
      let oldSymbolMatch = store.getState().gSymbol.symbolMatch ?? {};
      let matchInfos = message.split(wsMsgSeparatorChar.ObjectSeparatorChar);
      for (let mIdx = 0; mIdx < matchInfos.length; mIdx++) {
         let matchInfo = matchInfos[mIdx];
         if (matchInfo === "") {
            continue;
         }
         const firstIdx = matchInfo.indexOf(wsMsgSeparatorChar.PropSeparatorChar);
         if (firstIdx < 0) {
            continue;
         }
         const code = matchInfo.substr(0, firstIdx);
         //
         let oldMatchBySymbol = oldSymbolMatch[code] ?? { counter: 0, datas: [] }; // { counter: 0, datas: [{ time: 0, openPrice: 0, closePrice: 0, lowestPrice: 0, highestPrice: 0, volume: 0 }, ...]}
         const dataByTimes = matchInfo.substr(firstIdx).split(wsMsgSeparatorChar.PropSeparatorChar);
         for (let dIdx = 0; dIdx < dataByTimes.length; dIdx++) {
            if (dataByTimes[dIdx] !== "") {
               const propDatas = dataByTimes[dIdx].split(wsMsgSeparatorChar.DataSeparatorChar);
               const time = Number(propDatas[0]);
               let datas = oldMatchBySymbol.datas ?? [];
               const idx = datas.findIndex((el) => el.time === time);
               if (idx < 0) {
                  datas.push({
                     time: time,
                     openPrice: Number(propDatas[1]),
                     closePrice: Number(propDatas[2]),
                     lowestPrice: Number(propDatas[3]),
                     highestPrice: Number(propDatas[4]),
                     volume: Number(propDatas[5]),
                  });
               } else {
                  datas[idx].openPrice = Number(propDatas[1]);
                  datas[idx].closePrice = Number(propDatas[2]);
                  datas[idx].lowestPrice = Number(propDatas[3]);
                  datas[idx].highestPrice = Number(propDatas[4]);
                  datas[idx].volume = Number(propDatas[5]);
               }
               //
               oldMatchBySymbol.datas = datas;
               oldMatchBySymbol.counter = oldMatchBySymbol.counter + 1;
            }
         }
         //
         oldSymbolMatch[code] = oldMatchBySymbol;
      }
      //
      store.dispatch(updateSymbolChart(oldSymbolMatch));
   } catch (error) {}
};

//
export const ProcessMsgStockPriceChart = (message) => {
   try {
      if (message === undefined || message === null || message === "") {
         return;
      }
      //
      let oldSymbolPriceChart = store.getState().gSymbol.symbolPriceChart ?? {};
      let matchInfos = message.split(wsMsgSeparatorChar.ObjectSeparatorChar);
      for (let mIdx = 0; mIdx < matchInfos.length; mIdx++) {
         let matchInfo = matchInfos[mIdx];
         if (matchInfo === "") {
            continue;
         }
         const firstIdx = matchInfo.indexOf(wsMsgSeparatorChar.PropSeparatorChar);
         if (firstIdx < 0) {
            continue;
         }
         const code = matchInfo.substr(0, firstIdx);
         //
         let oldInfo = oldSymbolPriceChart[code] ?? { counter: 0, datas: [] }; // { counter: 0, datas: [{price: 0, quantity: 0},...]}
         const dataByPrices = matchInfo.substr(firstIdx).split(wsMsgSeparatorChar.PropSeparatorChar);
         for (let dIdx = 0; dIdx < dataByPrices.length; dIdx++) {
            if (dataByPrices[dIdx] !== "") {
               const propDatas = dataByPrices[dIdx].split(wsMsgSeparatorChar.DataSeparatorChar);
               const price = Number(propDatas[0]);
               let datas = oldInfo.datas ?? [];
               const idx = datas.findIndex((el) => el.price === price);
               if (idx < 0) {
                  datas.push({ price: price, quantity: Number(propDatas[1]) });
               } else {
                  datas[idx].quantity = Number(propDatas[1]);
               }
               //
               oldInfo.datas = datas;
               oldInfo.counter = oldInfo.counter + 1;
            }
         }
         //
         oldSymbolPriceChart[code] = oldInfo;
      }
      //
      store.dispatch(updateSymbolPriceChart(oldSymbolPriceChart));
   } catch (error) {}
};

//
export const ProcessMsgStockPutThrough = (message) => {
   try {
      if (message === undefined || message === null || message === "") {
         return;
      }
      //
      let storedPutThroughInfo = store.getState().gSymbol.putThroughInfo ?? { counter: 0, datas: [] }; // {counter: 0, datas: [{ticks, code, time,...},...]}
      let storedDatas = storedPutThroughInfo.datas ?? [];

      let changeCodes = [];
      let newInfos = [];

      const msgInfos = message.split(wsMsgSeparatorChar.ObjectSeparatorChar);
      for (let mIdx = 0; mIdx < msgInfos.length; mIdx++) {
         const msg = msgInfos[mIdx];
         if (msg === "") {
            continue;
         }
         const firstIdx = msg.indexOf(wsMsgSeparatorChar.PropSeparatorChar);
         if (firstIdx < 0) {
            continue;
         }
         const code = msg.substr(0, firstIdx);
         const msgProps = msg.substr(firstIdx).split(wsMsgSeparatorChar.PropSeparatorChar);
         let hasData = false;
         let objInfo = { ticks: 0, code: code };
         //
         for (let pIdx = 0; pIdx < msgProps.length; pIdx++) {
            const propInfo = msgProps[pIdx];
            if (propInfo === "") {
               continue;
            }
            //
            const propDatas = propInfo.split(wsMsgSeparatorChar.DataSeparatorChar);
            if (propDatas.length >= 2) {
               objInfo[arrPutThroughMsgField[Number(propDatas[0])]] = propDatas[1];
               hasData = true;
               if (propDatas.length >= 3) {
                  objInfo[arrPutThroughMsgField[Number(propDatas[0])] + "_color"] = arrColor[Number(propDatas[2])];
               }
            }
         }
         //
         if (hasData) {
            newInfos.push(objInfo);
         }
         if (changeCodes.some((e) => e === code) === false) {
            changeCodes.push(code);
         }
      }

      if (changeCodes.length > 0) {
         storedDatas = storedDatas.filter((e) => changeCodes.indexOf(e.code) < 0);
         storedDatas.push(...newInfos);

         storedPutThroughInfo.counter = storedPutThroughInfo.counter + 1;
         storedPutThroughInfo.datas = storedDatas;
      }
      //
      store.dispatch(updatePutThroughInfo(storedPutThroughInfo));
   } catch (error) {}
};

export const ProcessMsgStockTPRL = (message, isInit) => {
   try {
      // console.log(message, "message TPRL");
      let _old = store.getState().gSymbol.symbolTPRLInfos;

      let _msgs = message.split(wsMsgSeparatorChar.ObjectSeparatorChar);
      for (let _msgIdx = 0; _msgIdx < _msgs.length; _msgIdx++) {
         if (_msgs[_msgIdx] !== "") {
            const _firstIdx = _msgs[_msgIdx].indexOf(wsMsgSeparatorChar.PropSeparatorChar);
            const _code = _msgs[_msgIdx].substr(0, _firstIdx);
            let _rIndex = _old.findIndex((item) => item.code === _code);
            if (_rIndex < 0) {
               isInit = true;
               _old.push({ code: _code, counter: 0, closePriceHistChart: "", foreignTradeHistChart: "" });
               _rIndex = _old.length - 1;
            }
            //
            let _objTemp = _old[_rIndex];
            let _changed = false;
            const _arrData = _msgs[_msgIdx].substr(_firstIdx).split(wsMsgSeparatorChar.PropSeparatorChar);

            for (let _dataIdx = 0; _dataIdx < _arrData.length; _dataIdx++) {
               if (_arrData[_dataIdx] !== "") {
                  let _arrSubData = _arrData[_dataIdx].split(wsMsgSeparatorChar.DataSeparatorChar);
                  const _propIndex = Number(_arrSubData[0]);
                  if (_propIndex < arrStockTPRLField.length) {
                     let _objProp = arrStockTPRLField[_propIndex];
                     _objTemp[_objProp] = _arrSubData[1];
                     if (_arrSubData.length >= 3) {
                        _objTemp[_objProp + "_color"] = arrColorTPRL[Number(_arrSubData[2])];
                     }
                     _changed = true;
                  }
               }
            }
            //
            if (_changed) {
               _objTemp.counter = _objTemp.counter ?? 0 + 1;
            }
            //

            _old[_rIndex] = _objTemp;
         }
      }
      store.dispatch(updateSymbolTPRLInfos(_old, isInit));
   } catch (error) {}
};
